import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
	plugins: [createPersistedState()],
	state: {
		auth: null,
		isInAppBase: false,
	},
	mutations: {
		basic (state, payload) {
			state[payload.key] = payload.value;
		},
	},
	actions: {

	}
})
